(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('AvmPrequalifications', AvmPrequalifications);

    AvmPrequalifications.$inject = ['$resource'];

    function AvmPrequalifications ($resource) {
        return $resource('api/reports/avm-prequalifications/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            // The request node the probe was sent with. Same handling as the response below.
            'getRequestJson': {
                method: 'GET',
                url: 'api/reports/avm-prequalifications/:id/request',
                transformResponse: function (data) {
                    return { content: data };
                }
            },
            // The client-facing halves of the exchange: what was posted to pre-flight and what we
            // answered. On an order result these are the probe's, carried forward.
            'getClientRequestBody': {
                method: 'GET',
                url: 'api/reports/avm-prequalifications/:id/request-body',
                transformResponse: function (data) {
                    return { content: data };
                }
            },
            'getClientResponseBody': {
                method: 'GET',
                url: 'api/reports/avm-prequalifications/:id/response-body',
                transformResponse: function (data) {
                    return { content: data };
                }
            },
            // The payload we actually POSTed to Gnowise, which the request node above is NOT: the
            // translator drops fields, rebuilds the address and re-nests the attributes on its way out.
            'getUpstreamRequest': {
                method: 'GET',
                url: 'api/reports/avm-prequalifications/:id/upstream-request',
                transformResponse: function (data) {
                    return { content: data };
                }
            },
            // The raw Gnowise body for one probe, on demand. The server returns it already pretty-printed,
            // so the text passes through verbatim and the dialog renders it in a <pre> — no client-side
            // parsing, which would choke on Gnowise's non-standard NaN.
            'getRawResponse': {
                method: 'GET',
                url: 'api/reports/avm-prequalifications/:id/raw-response',
                transformResponse: function (data) {
                    return { content: data };
                }
            },
            // CSV export honoring the current filters; bytes wrapped in a Blob for FileSaver.
            'export': {
                method: 'GET',
                url: 'api/reports/avm-prequalifications/export',
                responseType: 'arraybuffer',
                transformResponse: function (data) {
                    if (data) {
                        return { file: new Blob([data], { type: 'text/csv' }) };
                    }
                    return data;
                }
            }
        });
    }
})();
